import { ContactDetailsSectionWebComponent } from './component/ContactDetailsSectionWebComponent';
import { WEB_COMPONENT_MDR_CONTACT_DETAILS_SECTION } from '../../../../webcomponents.constants';

export { ContactDetailsSectionWebComponent };

window.customElements.define(WEB_COMPONENT_MDR_CONTACT_DETAILS_SECTION, ContactDetailsSectionWebComponent);
